"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpStudentsDetailsNewRead = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var isUndefined_1 = __importDefault(require("lodash/isUndefined"));
var api_1 = require("../../../api");
var DpSectionCard_1 = require("../Cards/DpSectionCard");
var models_1 = require("../../../api/models");
var DpStudentsDetailsHeader_1 = __importDefault(require("./Components/DpStudentsDetailsHeader"));
var DpStudentsDetails_styled_1 = require("./DpStudentsDetails.styled");
var DpDetailedSectionTable_1 = require("./Components/DpDetailedSectionTable");
var DpStudentsDetailsNewRead = function (_a) {
    var assessment = _a.assessment, section = _a.section, assigneePerformance = _a.assigneePerformance, overallPerformance = _a.overallPerformance, _b = _a.columnsToShow, columnsToShow = _b === void 0 ? 1 : _b, type = _a.type, goToStudentReportHandler = _a.goToStudentReportHandler;
    // --------------------------- Const
    var t = (0, react_i18next_1.useTranslation)('common').t;
    // --------------------------- State
    var _c = (0, react_1.useState)(false), initialized = _c[0], setInitialized = _c[1];
    var _d = (0, react_1.useState)([]), headerColumns = _d[0], setHeaderColumns = _d[1];
    var _e = (0, react_1.useState)([]), tableData = _e[0], setTableData = _e[1];
    var items = (0, react_1.useMemo)(function () { return overallPerformance === null || overallPerformance === void 0 ? void 0 : overallPerformance.itemQuestionsPerformance.map(function (_a) {
        var itemExternalId = _a.itemExternalId;
        return itemExternalId;
    }); }, [overallPerformance]);
    var itemsFromAssessment = (0, react_1.useMemo)(function () { return models_1.AssessmentTemplate.findCoreItems([assessment.assessmentTemplate]); }, [assessment]);
    // --------------------------- Methods
    var parseTableData = (0, react_1.useCallback)(function (assigneesPerformanceData, overallAssigneesPerformance) {
        if (!(0, isEmpty_1.default)(assigneesPerformanceData) && overallAssigneesPerformance) {
            var formattedData = [
                {
                    id: 'overall',
                    name: t('studentsDetails.table.overall'),
                    multipleAttempts: false,
                    assessment: {
                        score: overallAssigneesPerformance.score,
                        maxScore: overallAssigneesPerformance.maxScore,
                        percentage: overallAssigneesPerformance.overallPercentage,
                    },
                    columns: items.map(function (itemId) {
                        var performanceItem = overallAssigneesPerformance.itemQuestionsPerformance.find(function (_a) {
                            var itemExternalId = _a.itemExternalId;
                            return itemExternalId === itemId;
                        });
                        var _a = performanceItem || {}, score = _a.score, maxScore = _a.maxScore, percentage = _a.percentage;
                        return {
                            score: score,
                            maxScore: maxScore,
                            percentage: percentage,
                        };
                    }),
                },
            ];
            var assigneesParseData = assigneesPerformanceData.map(function (performance) { return ({
                id: performance.assignee.id,
                name: "".concat(performance.assignee.lastName, ", ").concat(performance.assignee.firstName),
                multipleAttempts: false,
                assessment: {
                    score: performance.score,
                    maxScore: performance.maxScore,
                    percentage: performance.overallPercentage,
                },
                columns: items.map(function (itemId) {
                    var performanceItem = performance.itemQuestionsPerformance.find(function (_a) {
                        var externalQuestionId = _a.externalQuestionId;
                        return externalQuestionId === itemId;
                    });
                    var _a = performanceItem || {}, score = _a.score, maxScore = _a.maxScore, percentage = _a.percentage;
                    return {
                        score: score,
                        maxScore: maxScore,
                        percentage: percentage,
                    };
                }),
            }); });
            return formattedData.concat(assigneesParseData);
        }
    }, [t, items]);
    var parseReportData = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var headers, data;
        return __generator(this, function (_a) {
            headers = (0, api_1.getItemPartsLabels)(overallPerformance.itemQuestionsPerformance, itemsFromAssessment);
            setHeaderColumns(headers);
            data = parseTableData(assigneePerformance, overallPerformance);
            setTableData(data);
            setInitialized(true);
            return [2 /*return*/];
        });
    }); }, [assigneePerformance, overallPerformance, parseTableData, itemsFromAssessment]);
    var header = ((0, jsx_runtime_1.jsx)(DpStudentsDetailsHeader_1.default, { title: section.name, highlight: false, totalStudents: assigneePerformance.length }));
    (0, react_1.useEffect)(function () {
        if (assigneePerformance && overallPerformance) {
            parseReportData();
        }
    }, [assessment, section, parseReportData, assigneePerformance, overallPerformance]);
    return (initialized &&
        !(0, isUndefined_1.default)(tableData) && ((0, jsx_runtime_1.jsx)(DpStudentsDetails_styled_1.StyledStudentsDetails, { "data-testid": "student-details-new-read", children: (0, jsx_runtime_1.jsx)(DpSectionCard_1.DpSectionCard, { title: header, children: (0, jsx_runtime_1.jsx)(DpDetailedSectionTable_1.DpDetailedSectionTable, { sectionData: tableData, columnsToShow: columnsToShow, headerColumns: headerColumns, multipleSections: false, classId: section.id, type: type, goToStudentReportHandler: goToStudentReportHandler }) }) }, section.id)));
};
exports.DpStudentsDetailsNewRead = DpStudentsDetailsNewRead;
exports.default = exports.DpStudentsDetailsNewRead;
